// /home/szymon/kreator2/frontend/src/components/editor/useEditorShortcuts.js
import { useEffect } from "react";

export function useEditorShortcuts({
  selectedShapeId,
  isAccepted,
  publicMode,
  setSelectedShapeId,
  updatePages,
  currentPage,
  undo,
  redo
}) {
  useEffect(() => {
    function handleKeyDown(e) {
      // Skrót Delete (usuwa zaznaczony obiekt)
      if (e.key === "Delete") {
        if (!selectedShapeId) return;
        if (publicMode && isAccepted) {
          return;
        }
        updatePages((prev) => {
          const arr = [...prev];
          if (currentPage < 0 || currentPage >= arr.length) return arr;
          const pgCopy = { ...arr[currentPage] };
          pgCopy.texts = pgCopy.texts.filter((t) => t.id !== selectedShapeId);
          pgCopy.images = pgCopy.images.filter((m) => m.id !== selectedShapeId);
          pgCopy.svgs = pgCopy.svgs.filter((s) => s.id !== selectedShapeId);
          arr[currentPage] = pgCopy;
          return arr;
        });
        setSelectedShapeId(null);
      }

      // Skróty Ctrl+Z (Undo) lub Ctrl+Shift+Z (Redo)
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "z") {
        e.preventDefault();
        if (e.shiftKey) {
          if (redo) redo();
        } else {
          if (undo) undo();
        }
      }
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    selectedShapeId,
    isAccepted,
    publicMode,
    setSelectedShapeId,
    updatePages,
    currentPage,
    undo,
    redo
  ]);
}
